<template>
	<div class="text--primary">
		<template v-if="wrappedReal && awaitingStep">
			<v-row>
				<v-col class="py-2">
					<template v-if="awaitingStep.tooltip && awaitingStep.tooltip.length">
						<v-tooltip left open-delay="300">
							<template v-slot:activator="{ on }">
								<div v-on="on">
									{{ awaitingStep.name }}
								</div>
							</template>
							{{ awaitingStep.tooltip }}
						</v-tooltip>
					</template>
					<template v-else>
						{{ awaitingStep.name }}
					</template>
				</v-col>

				<v-col cols="2" class="py-1">
					<v-icon>
						schedule
					</v-icon>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-4">
					<v-btn
						small
						block text
						@click="wrappedReal = false"
					>
						<v-icon>keyboard_arrow_down</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</template>
		<template v-else>
			<v-row v-for="(step, i) in computedSteps" :key="i">
				<v-col class="py-2">
					<template v-if="step.tooltip && step.tooltip.length">
						<v-tooltip left open-delay="300">
							<template v-slot:activator="{ on }">
								<div v-on="on" class="pa-0 ma-0">
									{{ step.name }}
								</div>
							</template>
							{{ step.tooltip }}
						</v-tooltip>
					</template>
					<template v-else>
						{{ step.name }}
					</template>
				</v-col>

				<v-col cols="2" class="py-1">
					<v-icon v-if="step.approved" color="green">
						check_circle
					</v-icon>
					<v-icon v-else-if="step.rejected" color="red">
						remove_circle
					</v-icon>
					<v-icon v-else-if="step.awaiting">
						schedule
					</v-icon>
					<v-icon v-else>
						radio_button_unchecked
					</v-icon>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import _ from 'lodash'

export default {
	props: {
		steps: Array,
		status: Number,
		wrapped: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		wrappedReal: false
	}),
	computed: {
		computedSteps() {
			var s = _.cloneDeep(this.steps)
			var approved = true

			for (let i = 0; i < s.length; i++) {
				s[i].approved = Math.abs(this.status) > s[i].status

				if (this.status != 0 && this.status == -s[i].status) {
					s[i].rejected = true
					approved = false
				}
				else {
					s[i].rejected = false

					if (approved && !s[i].approved && !s[i].rejected) {
						if (this.status == s[i].status) {
							s[i].awaiting = true
						}
						approved = false
					}
					else {
						s[i].awaiting = false
					}
				}

			}
			return s
		},
		awaitingStep() {
			return this.computedSteps.filter(s => s.awaiting == true)[0]
		},
	},
	created() {
		this.wrappedReal = this.wrapped
	}
}

</script>
